console.log("Walking Character Script Loaded");

const initWalkingCharacters = () => {
    console.log("Initializing Walking Characters...");
    const containers = document.querySelectorAll('.walking-container');

    if (containers.length === 0) {
        console.log("No walking containers found.");
        return;
    }

    // Use a single observer for each batch or check observe status
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            // console.log("Intersection trigger:", entry.target.id, entry.isIntersecting);
            if (entry.isIntersecting) {
                const container = entry.target;
                const character = container.querySelector('.walking-character-wrapper');

                if (character) {
                    console.log("Starting animation for", character.id);
                    character.classList.add("is-moving");
                    observer.unobserve(container);
                }
            }
        });
    }, {
        rootMargin: "0px",
        threshold: 0.1
    });

    containers.forEach(container => {
        // Prevent attaching multiple observers
        if (container.dataset.observed === "true") return;

        const character = container.querySelector('.walking-character-wrapper');
        // If already moving, no need to observe (unless we want to support reset?)
        if (character && !character.classList.contains('is-moving')) {
            console.log("Observing:", container.id);
            observer.observe(container);
            container.dataset.observed = "true";
        }
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWalkingCharacters);
} else {
    initWalkingCharacters();
}

// Shopify Theme Editor Events
document.addEventListener('shopify:section:load', () => {
    console.log("Section Loaded (Theme Editor)");
    initWalkingCharacters();
});

document.addEventListener('shopify:section:select', function (event) {
    console.log("Section Selected (Theme Editor)", event.detail.sectionId);
    const section = document.getElementById("shopify-section-" + event.detail.sectionId);
    if (section) {
        const character = section.querySelector('.walking-character-wrapper');
        if (character) {
            character.classList.remove("is-moving");
            void character.offsetWidth; // Force reflow
            character.classList.add("is-moving");
        }
    }
});
